export const alertsRoutes = (root: string) => ({
  root,
  view: () => {
    return `${root}/view/:alertId`;
  },
  events: {
    root: `${root}/events`,
    view: () => {
      return `${root}/events/:eventId`;
    },
  },
  vibrationEvents: () => {
    return `${root}/vibration-events`;
  },
});
